import request from '@/utils/request'

export function paperList(data) {
  // 获取试卷内容
  return request({
    url: '/papers',
    method: 'get',
    params: data,
  })
}

export function paperSorts(data) {
  // 试题批量排序
  return request({
    url: '/question/sorts',
    method: 'post',
    data: data,
  })
}

export function paperReplace(data) {
  // 试题换题列表
  return request({
    url: '/question/replaces',
    method: 'get',
    params: data,
  })
}

export function paperReplaceComfirm(data) {
  // 试题换题确定
  return request({
    url: '/question/replaces',
    method: 'post',
    data: data,
  })
}

export function paperScore(data) {
  // 设置试卷得分
  return request({
    url: '/paper/scores',
    method: 'post',
    data: data,
  })
}

export function paperStatisticals(data) {
  // 试卷统计
  return request({
    url: '/paper/statisticals',
    method: 'get',
    params: data,
  })
}

export function savePaperStructures(data) {
  // 试卷结构保存
  return request({
    url: '/paper/structures',
    method: 'post',
    data: data,
  })
}

export function savePaperContent(data) {
  // 试卷内容保存
  return request({
    url: '/papers',
    method: 'put',
    data: data,
  })
}

export function paperPreDownload(data) {
  // 获取下载信息
  return request({
    url: '/paper/pre_download',
    method: 'get',
    params: data,
  })
}

export function createPaperOrder(data) {
  // 获取下载信息
  return request({
    url: '/paper/downloads',
    method: 'get',
    params: data,
  })
}

export function checkPaperOrder(data) {
  // 获取下载信息
  return request({
    url: '/order/check',
    method: 'get',
    params: data,
  })
}

export function paperDownloadUrl(data) {
  // 获取下载信息
  return request({
    url: '/order/download-urls',
    method: 'get',
    params: data,
  })
}

export function completePaper(paperId, title) {
  // 获取下载信息
  return request({
    url: `/paper/complete/${paperId}`,
    method: 'post',
    data: {
      title: title,
    },
  })
}